import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
interface MinistryCardProps {
  title: string;
  description: string;
  image: string;
  icon?: React.ReactNode;
  link?: string;
}
export function MinistryCard({
  title,
  description,
  image,
  icon,
  link = '/ministries'
}: MinistryCardProps) {
  return <motion.div whileHover={{
    y: -10
  }} className="group relative overflow-hidden rounded-xl bg-white shadow-lg h-full flex flex-col" data-id="element-232">
      <div className="relative h-48 overflow-hidden" data-id="element-233">
        <div className="absolute inset-0 bg-[#0A1F44]/20 group-hover:bg-[#0A1F44]/0 transition-colors z-10" data-id="element-234" />
        <img src={image} alt={title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-235" />
        {icon && <div className="absolute -bottom-6 right-6 w-12 h-12 bg-[#C8102E] rounded-full flex items-center justify-center text-white shadow-md z-20 group-hover:scale-110 transition-transform" data-id="element-236">
            {icon}
          </div>}
      </div>
      <div className="p-6 pt-10 flex-grow flex flex-col" data-id="element-237">
        <h3 className="text-xl font-bold font-serif mb-3 text-[#0A1F44]" data-id="element-238">
          {title}
        </h3>
        <p className="text-gray-600 mb-6 flex-grow line-clamp-3" data-id="element-239">
          {description}
        </p>
        <Link to={link} className="inline-flex items-center text-[#0A1F44] font-semibold hover:text-[#C8102E] transition-colors group-hover:translate-x-2 duration-300" data-id="element-240">
          Learn More <ArrowRight className="ml-2 w-4 h-4" data-id="element-241" />
        </Link>
      </div>
    </motion.div>;
}